// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const CreateClaimModalHeader = props =>
    <header>
        <span>
            <FormattedMessage id='CREATE_CLAIM'/>
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

CreateClaimModalHeader.displayName = 'CreateClaimModalHeader';
CreateClaimModalHeader.propTypes = {
    onCloseButtonClick: PropTypes.func.isRequired
};

export default CreateClaimModalHeader;



// WEBPACK FOOTER //
// ./src/shared/components/create-claim-modal/create-claim-modal-header.js